export const COMPANY_ADDRESS_FORMATS: Record<string, string> = {
  HK: `{countryCode}_{companyName}_{streetName}_{streetNumber}_{city}_{state}`,
  CN: `{countryCode}_{companyName}_{streetName}_{streetNumber}_{city}_{state}{zipCode}`,
  AE: `{countryCode}_{companyName}_{streetName}_{streetNumber}_{city}_{state}`,
  DE: `{countryCode}_{companyName}_{streetName}_{streetNumber}_{zipCode}{city}`,
  IN: `{countryCode}_{companyName}_{streetName}_{streetNumber}_{city}_{state}{zipCode}`,
}
export const COMPANY_ADDRESS_DEFAULT_FORMAT = `{countryCode}_{companyName}_{streetName}_{streetNumber}_{zipCode}{city}_{state}`
